import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-book-2-line',
    title: 'Genel Muhasebe Hizmetleri',
    desc: 'Günlük muhasebe kayıtları, defter tutma, bilanço ve gelir tablosu hazırlama işlemlerinin eksiksiz yürütülmesi.',
    color: 'bg-slate-50 text-[#0A2540]',
    href: '/genel-muhasebe',
    img: 'https://public.readdy.ai/ai/img_res/ffd306d1b5448953d52715729d089d31.jpg',
  },
  {
    icon: 'ri-percent-line',
    title: 'Vergi Danışmanlığı',
    desc: 'Kurumlar vergisi, gelir vergisi, KDV ve diğer vergi yükümlülüklerinde doğru beyan ve planlama desteği.',
    color: 'bg-emerald-50 text-emerald-700',
    href: '/vergi-danismanligi',
    img: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20calculator%20and%20tax%20forms%20on%20a%20clean%20white%20desk%2C%20coins%20stacked%20neatly%20beside%20documents%2C%20sharp%20focus%2C%20no%20text%20visible%2C%20soft%20warm%20studio%20light%2C%20minimal%20professional%20setting%2C%20high%20resolution%20photography%2C%20neutral%20background&width=600&height=400&seq=svc002&orientation=landscape&format=webp',
  },
  {
    icon: 'ri-group-line',
    title: 'SGK ve Bordro İşlemleri',
    desc: 'Çalışan bildirimleri, aylık bordro hesaplamaları, SGK prim beyannameleri ve işe giriş/çıkış işlemleri.',
    color: 'bg-amber-50 text-amber-700',
    href: '/sgk-bordro',
    img: 'https://readdy.ai/api/search-image?query=payroll%20salary%20documents%20and%20employee%20forms%20neatly%20arranged%20on%20a%20clean%20white%20desk%2C%20clipboard%20with%20blank%20papers%2C%20pen%20beside%20documents%2C%20no%20text%20visible%2C%20sharp%20focus%2C%20soft%20warm%20studio%20light%2C%20professional%20minimal%20office%20setting%2C%20high%20resolution%20photography%2C%20neutral%20white%20background&width=600&height=400&seq=svc003b&orientation=landscape&format=webp',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Şirket Kuruluş ve Yapılandırma',
    desc: 'Limited, anonim veya şahıs şirketi kuruluş süreçleri, vergi levhası, imza sirküleri ve tescil işlemleri.',
    color: 'bg-indigo-50 text-indigo-700',
    href: '/sirket-turu-secimi',
    img: 'https://readdy.ai/api/search-image?query=modern%20glass%20office%20building%20exterior%20with%20clean%20architectural%20lines%2C%20clear%20blue%20sky%20background%2C%20sharp%20professional%20photography%2C%20no%20signage%20or%20text%20visible%2C%20minimal%20elegant%20corporate%20architecture%2C%20high%20resolution%2C%20neutral%20tones&width=600&height=400&seq=svc004&orientation=landscape&format=webp',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Finansal Raporlama',
    desc: 'Yönetim kararlarını destekleyen aylık/yıllık finansal raporlar, nakit akış analizleri ve bütçe planlaması.',
    color: 'bg-rose-50 text-rose-700',
    href: '/mali-analiz',
    img: 'https://readdy.ai/api/search-image?query=financial%20growth%20charts%20and%20graphs%20printed%20on%20paper%20spread%20on%20a%20clean%20desk%2C%20bar%20charts%20and%20line%20graphs%20visible%2C%20no%20text%20labels%2C%20sharp%20focus%2C%20soft%20studio%20lighting%2C%20professional%20business%20analytics%20concept%2C%20minimal%20white%20background%2C%20high%20resolution&width=600&height=400&seq=svc005&orientation=landscape&format=webp',
  },
  {
    icon: 'ri-government-line',
    title: 'Teşvik ve Destek Danışmanlığı',
    desc: 'KOSGEB, TÜBİTAK, yatırım teşvikleri ve devlet desteklerinden yararlanma süreçlerinde rehberlik.',
    color: 'bg-teal-50 text-teal-700',
    href: '/tesvik-danismanligi',
    img: 'https://readdy.ai/api/search-image?query=two%20business%20professionals%20shaking%20hands%20in%20a%20bright%20modern%20office%2C%20formal%20professional%20attire%2C%20clean%20minimal%20interior%2C%20soft%20natural%20light%20through%20large%20windows%2C%20no%20text%20visible%2C%20high%20resolution%20corporate%20photography%2C%20warm%20neutral%20tones%2C%20trust%20and%20partnership%20concept&width=600&height=400&seq=svc006&orientation=landscape&format=webp',
  },
];

const moreServices = [
  { label: 'Şahıs Şirketi Kuruluşu', href: '/sahis-sirketi-kurulusu', icon: 'ri-user-line' },
  { label: 'Limited Şirket Kuruluşu', href: '/limited-sirket-kurulusu', icon: 'ri-building-line' },
  { label: 'E-Fatura / E-Arşiv', href: '/e-fatura-e-arsiv', icon: 'ri-file-text-line' },
  { label: 'Beyanname Hizmetleri', href: '/beyanname-hizmetleri', icon: 'ri-calendar-check-line' },
];

export default function Services() {
  return (
    <section id="hizmetler" className="py-24 md:py-32 bg-[#F5F7FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">Hizmet Alanları</span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mt-3 mb-4">
            Kapsamlı Mali Danışmanlık
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            İşletmenizin her aşamasında ihtiyaç duyduğunuz mali ve hukuki süreçlerde yanınızdayız.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <Link
              key={s.title}
              to={s.href}
              className="relative bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 group cursor-pointer block"
            >
              {/* Katman 1: Görsel — sağ üstte tam görünür */}
              <div className="absolute inset-0 z-0">
                <img
                  src={s.img}
                  alt=""
                  aria-hidden="true"
                  className="w-full h-full object-cover object-right-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Katman 2: Çapraz gradient — sağ üst şeffaf → sol alt beyaz */}
              <div className="absolute inset-0 z-10 bg-gradient-to-bl from-white/0 via-white/70 to-white"></div>

              {/* Katman 3: Hafif lacivert overlay — belli belirsiz ton */}
              <div className="absolute inset-0 z-20 bg-[#0A2540]/8"></div>

              {/* Content — en üstte, her zaman okunur */}
              <div className="relative z-30 p-8">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.color} mb-5`}>
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <h3 className="text-[#0A2540] font-semibold text-base mb-3 leading-snug group-hover:text-[#1a4a7a] transition-colors">{s.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{s.desc}</p>
                <div className="flex items-center gap-1 text-[#0A2540]/50 text-xs font-medium group-hover:text-[#0A2540] transition-colors">
                  <span>Detaylı bilgi</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* More Services */}
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {moreServices.map((s) => (
            <Link
              key={s.href}
              to={s.href}
              className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-200 text-[#0A2540] text-sm rounded-xl hover:border-[#0A2540] hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className={`${s.icon} text-sm`}></i>
              {s.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
